import { STRIPE_WORKER_URL } from '@/lib/env'
import { getSupabaseAuthToken } from '@/lib/supabaseClient'

export async function createCheckoutSession(
  organizationId: string,
  tier: 'pro' | 'business'
): Promise<void> {
  if (!STRIPE_WORKER_URL) {
    throw new Error('Stripe worker URL is not configured. Set VITE_STRIPE_WORKER_URL.')
  }
  const token = await getSupabaseAuthToken()
  const res = await fetch(`${STRIPE_WORKER_URL}/checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ organizationId, tier }),
  })
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText)
    throw new Error(`Checkout session failed: ${text}`)
  }
  const { url } = (await res.json()) as { url: string }
  window.location.href = url
}

export async function createPortalSession(organizationId: string): Promise<void> {
  if (!STRIPE_WORKER_URL) {
    throw new Error('Stripe worker URL is not configured. Set VITE_STRIPE_WORKER_URL.')
  }
  const token = await getSupabaseAuthToken()
  const res = await fetch(`${STRIPE_WORKER_URL}/portal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ organizationId }),
  })
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText)
    throw new Error(`Portal session failed: ${text}`)
  }
  const { url } = (await res.json()) as { url: string }
  window.location.href = url
}
